import { CustomFieldClassTypeItem } from './CustomFieldClassTypeItem'

export const FieldDesignChange = new CustomFieldClassTypeItem({
  id: '57a54287-a5e0-4aa1-8f82-b715e305a969',
  type: 'Field Design Change',
  classType: 'FieldDesignChange',
})

export const IdentifiedFieldIssue = new CustomFieldClassTypeItem({
  id: '9ee9eb4a-f74b-4eb0-ad0c-58cd71dc1700',
  type: 'Identified Field Issue',
  classType: 'IdentifiedFieldIssue',
})

export const RequestForInformation = new CustomFieldClassTypeItem({
  id: '7b26a1de-f812-4e8a-b97d-49d18071b721',
  type: 'Request For Information',
  classType: 'RequestForInformation',
})

export const Issue = new CustomFieldClassTypeItem({
  id: '233aec42-e724-4b29-966d-1f2612e2717a',
  type: 'Issue',
  classType: 'Issue',
})

export const ConstructionAdminSubmittal = new CustomFieldClassTypeItem({
  id: 'ca56913f-78b5-4bd3-8f95-65e13e6cb1e9',
  type: 'Construction & Admin Submittal',
  classType: 'ConstructionAdminSubmittal',
})

export const EngineeringJudgement = new CustomFieldClassTypeItem({
  id: '7de2c76b-d749-4608-b68c-1c45dcb191ef',
  type: 'Engineering Judgement',
  classType: 'EngineeringJudgement',
})

export const ConcreteMixDesign = new CustomFieldClassTypeItem({
  id: 'e7f64b0d-57d8-49e4-817d-523f07c97221',
  type: 'Concrete Mix Design',
  classType: 'ConcreteMixDesign',
})

export const AsphaltMixDesign = new CustomFieldClassTypeItem({
  id: 'ce93f2cc-e74d-4ed9-9c05-21a196a77976',
  type: 'Asphalt Mix Design',
  classType: 'AsphaltMixDesign',
})

export const DesignSubmittal = new CustomFieldClassTypeItem({
  id: 'e66276e6-5b74-46f2-b452-45cd00c800c7',
  type: 'Design Submittal',
  classType: 'DesignSubmittal',
})
